"use client";

import { useMemo } from "react";
import { usePathname, useRouter } from "next/navigation";
import { TabMenu } from "primereact/tabmenu";
import { useCurrentUser } from "@/hooks/useCurrentUser";

const ALL_SETTING_TABS = [
  { label: "Translation Dictionary", path: "/setting/translation", requiredCode: null },
  { label: "User Management", path: "/setting/users", requiredCode: "user:update:all" },
];

export default function SettingLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const router = useRouter();
  const currentUser = useCurrentUser();

  const tabs = useMemo(() => {
    const isSuperAdmin = currentUser?.isSuperAdmin === true;
    return ALL_SETTING_TABS.filter(
      (t) => t.requiredCode === null || isSuperAdmin || (currentUser?.permissionCodes?.includes(t.requiredCode) ?? false)
    );
  }, [currentUser]);

  const activeIndex = Math.max(0, tabs.findIndex((t) => pathname.startsWith(t.path)));

  return (
    <div className="flex h-full w-full flex-col bg-white">
      <TabMenu
        model={tabs.map((t) => ({ label: t.label }))}
        activeIndex={activeIndex}
        onTabChange={(e) => router.push(tabs[e.index].path)}
        className="px-6"
      />
      <div className="min-h-0 flex-1 overflow-hidden p-6">
        {children}
      </div>
    </div>
  );
}
